import React, { Component } from "react";
import { connect } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toggleEditSEOCodeEditor } from "GeneralTabAction";
import { DOMAIN_NAME } from "Constants";
import EditSEOName from "./edit-seo-url";
import LocaleStrings from "Languages";

class SeoUrl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
  }

  onClickEditName(e) {
    this.props.toggleEditSEOCodeEditor(true);
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  render() {
    var { eventData, toEditSEOName } = this.props;
    var url = eventData
      ? `https://${eventData.seocode}.${DOMAIN_NAME}/q/#/overview`
      : `https://${DOMAIN_NAME}`;

    return (
      <div className="">
        <div className="control-label-top">
          {LocaleStrings.general_form_label_seocode_url}
        </div>
        <div className="row">
          {toEditSEOName ? (
            <EditSEOName eventData={eventData ? eventData : ""} />
          ) : (
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-7 px-0 vertical-align-center-justify-between">
                <div className="seocode-url-display">
                  https://
                  {eventData ? eventData.seocode : ""}
                  <span>.{DOMAIN_NAME}/q/#/overview</span>
                </div>

                <img
                  style={{ marginTop: 1 }}
                  className="i-custom-big"
                  onClick={this.onClickEditName.bind(this)}
                  src="../../style/images/custom-icons/edit.svg"
                />
              </div>

              <div className="col-md-5 seo-button">
                <CopyToClipboard text={url} onCopy={this.copyUrl}>
                  {this.state.copied ? (
                    <a className="btn btn-custom-blue btn-v-center">
                      <i
                        className="fa fa-files-o i-custom-m"
                        aria-hidden="true"
                      ></i>
                      &nbsp; {LocaleStrings.copied}
                    </a>
                  ) : (
                    <a className="btn btn-custom-blue btn-v-center">
                      <i
                        className="fa fa-files-o i-custom-m"
                        aria-hidden="true"
                      ></i>
                      &nbsp; {LocaleStrings.button_copy}
                    </a>
                  )}
                </CopyToClipboard>
                <a
                  href={url}
                  target="blank"
                  className="btn btn-custom-blue btn-v-center"
                  style={{ marginLeft: 10 }}
                >
                  <span aria-hidden="true">{LocaleStrings.button_visit}</span>
                </a>
              </div>
            </div>
          )}
        </div>
        <div className="col-md-12 custom-text2-secondary-normal">
          * {LocaleStrings.general_form_label_seocode_url_note1}.
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let eventData = {};
  if (state.eventData && state.eventData.length > 0) {
    eventData = state.eventData[0];
  }

  return {
    toEditSEOName: state.editSeoCode,
    eventData,
  };
}

export default connect(mapStateToProps, { toggleEditSEOCodeEditor })(SeoUrl);
